module.exports = __webpack_public_path__ + "assets/img/box5_img1.ee4ad70c.png";